import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import SearchService from "./SearchService";

// TODO: Mover el estado a un componente padre
const HeaderNavContent = () => {
  const { user, token } = useSelector((state: { user }) => state.user);
  const isWorker = user.type === "worker";
  const { pathname } = useLocation();

  return (
    <>
      <nav className="nav main-menu">
        <ul className="navigation" id="navbar">
          {isWorker && token && (
            <li style={{ marginRight: 40 }}>
              <Link to="/dashboard" className="theme-btn btn-style-nine">
                Panel del profesional
              </Link>
            </li>
          )}
          {!isWorker && token && (
            <li>
              <Link to="/dashboard" className="theme-btn btn-style-nine">
                Dashboard
              </Link>
            </li>
          )}
          {pathname !== "/" && <SearchService />}
        </ul>
      </nav>
    </>
  );
};

export default HeaderNavContent;
